
import React from 'react';
import { motion } from 'framer-motion';
import { Users, MessageSquare, Calendar, Award } from 'lucide-react';
import { fadeIn, staggerContainer } from './communityData';
import TranslatedText from '@/TranslatedText';

const CommunityStats: React.FC = () => {
  return (
    <motion.div 
      className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" 
      variants={staggerContainer} 
      initial="hidden" 
      animate="visible"
    >
      <motion.div variants={fadeIn} className="bg-white rounded-xl p-4 shadow-sm flex flex-col items-center text-center">
        <Users className="h-8 w-8 text-ahavex-blue mb-2" />
        <span className="text-xl md:text-2xl font-bold">12.5K+</span>
        <span className="text-gray-500 text-sm">
          <TranslatedText text="Community Members" />
        </span>
      </motion.div>
      
      <motion.div variants={fadeIn} className="bg-white rounded-xl p-4 shadow-sm flex flex-col items-center text-center">
        <MessageSquare className="h-8 w-8 text-ahavex-blue mb-2" />
        <span className="text-xl md:text-2xl font-bold">8.3K+</span>
        <span className="text-gray-500">
          <TranslatedText text="Active Discussions" />
        </span>
      </motion.div>
      
      <motion.div variants={fadeIn} className="bg-white rounded-xl p-4 shadow-sm flex flex-col items-center text-center">
        <Calendar className="h-8 w-8 text-ahavex-blue mb-2" />
        <span className="text-xl md:text-2xl font-bold">120+</span>
        <span className="text-gray-500">
          <TranslatedText text="Monthly Events" />
        </span>
      </motion.div>
      
      <motion.div variants={fadeIn} className="bg-white rounded-xl p-4 shadow-sm flex flex-col items-center text-center">
        <Award className="h-8 w-8 text-ahavex-blue mb-2" />
        <span className="text-xl md:text-2xl font-bold">45+</span>
        <span className="text-gray-500">
          <TranslatedText text="Countries Represented" />
        </span>
      </motion.div>
    </motion.div>
  );
};

export default CommunityStats;
